/* Marbury Lane bundle.

   Two independent widgets:
     1. The bundle tier ladder, ported from the previous store.
     2. The product-info video slider.

   ---------------------------------------------------------------------------
   TIER LADDER — CONTRACT WITH product-form.js. Do not drift from this.

   product-form.js does:
     this.quantityBreaks = document.getElementById(`quantity-breaks-${this.dataset.section}`)
     ... if (this.quantityBreaks.formVariants.length > 0) -> emits, per entry:
         <input name="items[n][quantity]" value="..."><input name="items[n][id]" value="...">

   Therefore the root element MUST keep id="quantity-breaks-{{ section.id }}"
   and MUST expose .formVariants as an array of { id, quantity }.

   The empty array is a meaningful, load-bearing state: when formVariants is
   empty, product-form.js falls through to the ordinary single [name=id] path.
   That is exactly what we want if variant resolution fails, so a misconfigured
   product degrades to a working plain Add to Cart instead of a dead button.

   Shrine's own quantity-breaks snippet claims the SAME element id. Only one of
   the two may be active on a page. This ladder replaces it.
   ---------------------------------------------------------------------------
   HOW THIS DIFFERS FROM THE STORE IT WAS PORTED FROM

   There, each tier mapped to its own fixed Shopify variant (cushion, cushion +
   cover, two-pack), so the ladder owned the variant choice outright.

   Here the shopper picks a metal from the swatch picker and the tiers are
   quantities of THAT variant. So the ladder follows the picker instead of
   owning it: the selected variant is read from the product form's hidden
   [name="id"] input on every render, and a variant change re-renders the whole
   ladder so prices track the metal.

   PRICES ARE NEVER HARDCODED. Unit price is read from the real variant object,
   so the page cannot contradict Shopify. Each tier carries data-fixed-off in
   cents, which must equal the matching Shopify automatic discount. If that
   discount is ever changed or removed, change this too, or the ladder quotes a
   price the cart will not honour. */

(function () {
  'use strict';

  function init() {
    var root = document.querySelector('[data-ml-bundle]');
    if (!root || root._mlInit) return;
    root._mlInit = true;

    /* Always define the property, even on the failure paths below. An undefined
       .formVariants would throw in product-form.js on the .length read. */
    root.formVariants = [];

    var variants = [];
    var variantsNode = root.querySelector('[data-ml-variants]');
    if (variantsNode) {
      try { variants = JSON.parse(variantsNode.textContent) || []; } catch (e) { variants = []; }
    }
    if (!Array.isArray(variants)) variants = [];

    var tiers = Array.prototype.slice.call(root.querySelectorAll('.ml-bun__tier'));
    if (!tiers.length) return;

    /* Scoped to the product section so nothing here can reach a price or a form
       in a related-products grid or the cart drawer. */
    var section = root.closest ? root.closest('.shopify-section') : null;
    var scope = section || document;
    var priceBlock = scope.querySelector('[id^="main-price-"]');
    var form = scope.querySelector('product-form form') ||
               scope.querySelector('form[action*="/cart/add"]');

    var currency = root.getAttribute('data-currency') || 'USD';
    var fmt;
    try {
      fmt = new Intl.NumberFormat('en-US', {
        style: 'currency', currency: currency,
        minimumFractionDigits: 2, maximumFractionDigits: 2
      });
    } catch (e) {
      fmt = { format: function (n) { return '$' + n.toFixed(2); } };
    }
    function money(cents) { return fmt.format((cents || 0) / 100); }

    /* The swatch picker rewrites the form's hidden [name="id"] on every change,
       so that input is the single source of truth for which metal is selected.
       Falling back to the first available variant keeps the ladder priced
       sensibly in the theme editor, before any picker exists. */
    function currentVariant() {
      var input = form && form.querySelector('[name="id"]');
      var id = input ? parseInt(input.value, 10) : NaN;
      if (!isNaN(id)) {
        for (var i = 0; i < variants.length; i++) {
          if (variants[i].id === id) return variants[i];
        }
      }
      for (var j = 0; j < variants.length; j++) {
        if (variants[j].available !== false) return variants[j];
      }
      return variants[0] || null;
    }

    function variantById(id) {
      if (id == null) return null;
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].id === id) return variants[i];
      }
      return null;
    }

    /* PER-ITEM SELECTION STATE.

       tier._mlItems is an array of variant ids whose length is that tier's
       data-qty. It is the only state the dropdowns own, and it is deliberately
       held on the DOM node rather than in a map so the theme editor's section
       reload throws it away with the node.

       SEEDING IS STRICTLY ONE WAY. The swatch picker writes into _mlItems; a
       dropdown NEVER writes back to the form's hidden [name="id"]. Writing back
       would fire PUB_SUB_EVENTS.variantChange and the form's own change route,
       both of which land in render() below, which re-seeds every tier — a loop
       that would wipe the shopper's choices the instant they made one. It would
       also leave the swatch picker's own UI showing a metal the shopper never
       clicked.

       lastPickerId is declared here, inside init(), so a shopify:section:load
       re-init starts from undefined and seeds on its first render. */
    var lastPickerId;

    function seedAllTiers(id) {
      for (var i = 0; i < tiers.length; i++) {
        var q = parseInt(tiers[i].getAttribute('data-qty'), 10) || 1;
        var arr = [];
        for (var j = 0; j < q; j++) arr.push(id);
        tiers[i]._mlItems = arr;
      }
    }

    /* Pushes _mlItems out to the DOM. Assigning select.value works even when the
       target <option> is disabled, so a seeded sold-out variant still displays
       rather than collapsing the select to a blank. */
    function syncSelects(tier) {
      var sels = tier.querySelectorAll('.ml-bun__var');
      var items = tier._mlItems || [];
      for (var i = 0; i < sels.length; i++) {
        var want = items[i] == null ? '' : String(items[i]);
        if (sels[i].value !== want) sels[i].value = want;
      }
    }

    function tierData(tier) {
      var picker = currentVariant();
      var qty = parseInt(tier.getAttribute('data-qty'), 10) || 1;
      var off = parseInt(tier.getAttribute('data-fixed-off'), 10) || 0;

      var fallback = parseInt(root.getAttribute('data-fallback-price'), 10);
      var fallbackUnit = picker && typeof picker.price === 'number'
        ? picker.price
        : (isNaN(fallback) ? 0 : fallback);

      /* One entry per unit. Any slot the shopper has not touched falls back to
         the picker's variant, so a tier with no dropdowns at all (qty 1) and a
         tier whose dropdowns are all still on the seeded value both price
         exactly as they did before this feature existed. */
      var items = Array.isArray(tier._mlItems) ? tier._mlItems : [];
      var chosen = [];
      for (var i = 0; i < qty; i++) {
        chosen.push(variantById(items[i]) || picker || null);
      }

      /* Mixed selections mean the list total is the SUM of each item's own
         price, not one unit price times the quantity. With a uniform basket this
         is arithmetically identical to the old unit * qty. */
      var listTotal = 0;
      var available = true;
      for (var k = 0; k < chosen.length; k++) {
        var c = chosen[k];
        listTotal += (c && typeof c.price === 'number') ? c.price : fallbackUnit;
        if (!c || c.available === false) available = false;
      }

      var total = listTotal - off;
      if (total < 0) total = 0;

      /* The compare figure is the undiscounted total of these same line items,
         which is arithmetic the shopper can check against the cart, not an
         invented MSRP. Never advertise a saving that is not real. */
      var compare = off > 0 && listTotal > total ? listTotal : 0;

      return {
        variant: picker,
        items: chosen,
        qty: qty,
        total: total,
        compare: compare,
        save: compare ? compare - total : 0,
        available: available
      };
    }

    /* The theme's price block renders the default variant's single-unit price
       from Liquid and knows nothing about the ladder, so without this the page
       shows two different prices at once. Both the regular and sale branches
       are filled because they are mutually exclusive, switched by the class. */
    function syncPriceBlock(total, compare) {
      if (!priceBlock) return;
      var onSale = !!compare && compare > total;

      var reg = priceBlock.querySelector('.price__regular .price-item--regular');
      if (reg) reg.textContent = money(total);

      var sale = priceBlock.querySelector('.price__sale .price-item--sale');
      if (sale) sale.textContent = money(total);

      var cmp = priceBlock.querySelector('.price__compare-price s');
      if (cmp) cmp.textContent = onSale ? money(compare) : '';

      var cmpWrap = priceBlock.querySelector('.price__compare-price');
      if (cmpWrap) cmpWrap.hidden = !onSale;

      priceBlock.classList.toggle('price--on-sale', onSale);
    }

    function selectedTier() {
      for (var i = 0; i < tiers.length; i++) {
        var input = tiers[i].querySelector('.ml-bun__input');
        if (input && input.checked) return { tier: tiers[i], index: i };
      }
      return { tier: tiers[0], index: 0 };
    }

    function render() {
      /* Re-seed ONLY when the swatch picker's variant genuinely changed.

         render() also runs on every tier click and on every dropdown change, and
         an unconditional re-seed there would throw the shopper's per-item
         choices away the moment they made one. Keying on the picker id means all
         three outer variantChange routes below share one guard and none of them
         needs to know about _mlItems. */
      var picker = currentVariant();
      var pid = picker ? picker.id : null;
      if (pid !== lastPickerId) {
        lastPickerId = pid;
        seedAllTiers(pid);
      }

      var sel = selectedTier();

      for (var i = 0; i < tiers.length; i++) {
        var tier = tiers[i];
        var d = tierData(tier);
        var isSel = i === sel.index;

        syncSelects(tier);

        var priceEl = tier.querySelector('[data-ml-price]');
        if (priceEl) priceEl.textContent = money(d.total);

        var cmpEl = tier.querySelector('[data-ml-cmp]');
        if (cmpEl) {
          cmpEl.textContent = d.compare ? money(d.compare) : '';
          cmpEl.hidden = !d.compare;
        }

        /* Show the selected variant's own image, so the row reflects the metal
           the shopper actually picked rather than the product default. Stays on
           the PICKER's variant, not on the per-item selections: the thumbnail is
           a 56px square and cannot honestly represent a mixed basket. */
        var thumb = tier.querySelector('.ml-bun__img img');
        if (thumb && d.variant && d.variant.featured_image && d.variant.featured_image.src) {
          var src = d.variant.featured_image.src;
          if (src.indexOf('width=') === -1) {
            src += (src.indexOf('?') === -1 ? '?' : '&') + 'width=160';
          }
          if (thumb.getAttribute('src') !== src) thumb.setAttribute('src', src);
        }

        tier.classList.toggle('is-sel', isSel);
        tier.classList.toggle('is-unavailable', !d.available);

        var input = tier.querySelector('.ml-bun__input');
        if (input) {
          input.checked = isSel;
          input.disabled = !d.available;
        }
      }

      var chosen = tierData(sel.tier);

      /* The one line that actually decides what enters the cart.

         Identical ids collapse into a single line with a summed quantity, so two
         Gold go in as one items[0] with quantity 2 rather than as two lines the
         cart would merge anyway. Key is prefixed so an id can never collide with
         an Object.prototype member.

         A null anywhere in the list means variant resolution failed, and the
         WHOLE array is dropped. That empty array is the load-bearing state
         documented at the top of this file: product-form.js then falls through
         to the ordinary single [name=id] path, so a misconfigured product
         degrades to a working plain Add to Cart instead of a dead button. */
      var lines = [];
      var seen = {};
      for (var m = 0; m < chosen.items.length; m++) {
        var it = chosen.items[m];
        if (!it) { lines = []; break; }
        var key = 'v' + it.id;
        if (seen[key]) {
          seen[key].quantity += 1;
        } else {
          seen[key] = { id: it.id, quantity: 1 };
          lines.push(seen[key]);
        }
      }
      root.formVariants = lines;

      syncPriceBlock(chosen.total, chosen.compare);

      root.dispatchEvent(new CustomEvent('ml:bundle:change', {
        bubbles: true,
        detail: {
          index: sel.index, variant: chosen.variant, items: chosen.items,
          quantity: chosen.qty, total: chosen.total, compare: chosen.compare,
          save: chosen.save
        }
      }));
    }

    /* Both handlers are needed: `change` covers keyboard and assistive tech
       driving the radio directly, `click` covers taps anywhere on the label,
       which do not always fire `change` when the radio is already checked. */
    root.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !t.classList) return;

      if (t.classList.contains('ml-bun__input')) { render(); return; }

      /* A dropdown writes into its own tier's _mlItems and nowhere else. It must
         not touch the form's hidden [name="id"]: that input is the swatch
         picker's property, and writing to it would re-seed every tier through
         the variantChange routes below. See the note on _mlItems above. */
      if (t.classList.contains('ml-bun__var')) {
        var tier = t.closest && t.closest('.ml-bun__tier');
        if (!tier || !root.contains(tier)) return;
        var slot = parseInt(t.getAttribute('data-ml-slot'), 10);
        var vid = parseInt(t.value, 10);
        if (!isNaN(slot) && !isNaN(vid) &&
            Array.isArray(tier._mlItems) && slot < tier._mlItems.length) {
          tier._mlItems[slot] = vid;
          render();
        }
      }
    });

    root.addEventListener('click', function (e) {
      /* Never let a tap on a dropdown re-enter tier selection.

         The tier is a <label>, and the HTML spec says a label's activation
         behaviour does not run for events targeted at interactive-content
         descendants — <select> is interactive content — so this should be
         unnecessary. It is here anyway rather than trusting every mobile
         browser to agree. Harmless even if it never fires: the dropdowns are
         display:none on any tier that is not already selected. */
      if (e.target.closest && e.target.closest('.ml-bun__vars')) return;

      var tier = e.target.closest && e.target.closest('.ml-bun__tier');
      if (!tier || !root.contains(tier)) return;
      var input = tier.querySelector('.ml-bun__input');
      if (input && !input.disabled && !input.checked) { input.checked = true; render(); }
    });

    /* Follow the swatch picker. Three routes, because no single one is reliable
       across Shrine's variant paths: the theme's own pubsub, a direct change
       event on the form, and a mutation on the hidden input for the cases where
       the value is written programmatically without an event. */
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function () { render(); });
    }
    if (form) {
      form.addEventListener('change', function (e) {
        if (e.target && e.target.name === 'id') render();
      });
      var idInput = form.querySelector('[name="id"]');
      if (idInput && 'MutationObserver' in window) {
        new MutationObserver(function () { render(); })
          .observe(idInput, { attributes: true, attributeFilter: ['value'] });
      }
    }

    /* Preselect the tier marked data-default, else the FIRST tier.

       The fallback deliberately lands on the cheapest option. The main price
       block syncs to whichever tier is selected, so defaulting higher shows a
       first-time visitor a number well above the one the ad quoted. This used
       to fall back to the middle tier, which meant a silent Liquid bug in the
       data-default attribute went unnoticed for several rounds: the ladder
       looked deliberate while actually running on the fallback. */
    var pre = root.querySelector('.ml-bun__tier[data-default] .ml-bun__input');
    if (!pre) pre = tiers[0] && tiers[0].querySelector('.ml-bun__input');
    if (pre && !pre.disabled) pre.checked = true;

    render();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* Theme editor re-renders the section without a page load. */
  document.addEventListener('shopify:section:load', function () {
    var root = document.querySelector('[data-ml-bundle]');
    if (root) root._mlInit = false;
    init();
  });
})();

/* Product-info video slider.

   Class names and the element name are carried over from the previous build on
   purpose: they are wired into main-product.liquid and snippets/cz-video-slide
   .liquid, and renaming them would mean editing a 6,000-line section file for
   no user-visible gain.

   Deliberately does not use the theme's <internal-video>: that element has no
   sound capability, and its play button is a play/pause toggle that would fight
   tap-to-play-with-sound.

   Autoplay is muted, in view only, and one slide at a time is unmuted by tap.
   Autoplaying every slide at once would put eight simultaneous video streams on
   a phone, which is why the IntersectionObserver drives playback rather than
   the autoplay attribute. */
(function () {
  if (typeof customElements === 'undefined' || customElements.get('cz-video-slider')) return;

  var CzVideoSlider = function () {
    return Reflect.construct(HTMLElement, [], CzVideoSlider);
  };
  CzVideoSlider.prototype = Object.create(HTMLElement.prototype);
  CzVideoSlider.prototype.constructor = CzVideoSlider;
  Object.setPrototypeOf(CzVideoSlider, HTMLElement);

  CzVideoSlider.prototype.connectedCallback = function () {
    if (this._czInit) return;
    this._czInit = true;

    var self = this;
    this.track = this.querySelector('.cz-vs__list');
    this.videos = Array.prototype.slice.call(this.querySelectorAll('.cz-vs__video'));
    this.thumb = this.querySelector('.cz-vs__bar-thumb');
    if (!this.track) return;

    var wantsAutoplay = this.hasAttribute('data-autoplay');
    var reduced = window.matchMedia &&
                  window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var autoplay = wantsAutoplay && !reduced;

    /* Sound is exclusive: unmuting one card mutes every other, so audio never
       comes from two places at once. */
    function soloAudio(except) {
      self.videos.forEach(function (v) {
        if (v !== except) {
          v.muted = true;
          var b = v.closest('.cz-vs__media');
          var s = b && b.querySelector('.cz-vs__ctl--sound');
          if (s) s.setAttribute('aria-pressed', 'false');
        }
      });
    }

    this.querySelectorAll('.cz-vs__media').forEach(function (media) {
      var video = media.querySelector('.cz-vs__video');
      if (!video) return;
      var soundBtn = media.querySelector('.cz-vs__ctl--sound');
      var playBtn = media.querySelector('.cz-vs__ctl--play');

      function syncPlayBtn() {
        if (playBtn) playBtn.setAttribute('aria-pressed', video.paused ? 'false' : 'true');
        media.classList.toggle('is-playing', !video.paused);
      }

      var slide = media.closest('.cz-vs__slide');
      function markUserSet() { if (slide) slide.setAttribute('data-user-set', ''); }

      if (soundBtn) {
        soundBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          markUserSet();
          var turningOn = video.muted;
          if (turningOn) soloAudio(video);
          video.muted = !turningOn;
          if (turningOn) {
            video.volume = 1;
            var p = video.play();
            if (p && p.catch) p.catch(function () { video.muted = true; });
          }
          soundBtn.setAttribute('aria-pressed', video.muted ? 'false' : 'true');
          syncPlayBtn();
        });
      }

      if (playBtn) {
        playBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          markUserSet();
          if (video.paused) {
            var p = video.play();
            if (p && p.catch) p.catch(function () {});
          } else {
            video.pause();
          }
          syncPlayBtn();
        });
      }

      // Tapping the card body still unmutes and plays, as before.
      media.addEventListener('click', function () {
        markUserSet();
        if (video.muted || video.paused) {
          soloAudio(video);
          self.pauseAll(video);
          video.muted = false;
          video.volume = 1;
          var p = video.play();
          if (p && p.catch) {
            p.catch(function () { video.muted = true; video.play(); });
          }
          if (soundBtn) soundBtn.setAttribute('aria-pressed', 'true');
        } else {
          video.pause();
        }
        syncPlayBtn();
      });

      video.addEventListener('play', syncPlayBtn);
      video.addEventListener('pause', syncPlayBtn);
      video.addEventListener('ended', syncPlayBtn);
      syncPlayBtn();
    });

    /* Play muted while in view, pause on the way out.

       threshold is deliberately low. At 0.4 the edge slides of a 5-across strip
       with a peek are only ~35% visible, so they never qualified and never
       started — which is why "not all videos autoplay".

       A card the visitor has touched is left alone. Without that guard the
       observer pauses a video someone deliberately started the moment an
       unrelated scroll moves it, which reads as the controls being broken. */
    function isUserSet(slide) { return slide.hasAttribute('data-user-set'); }

    function autoplayIfIdle(slide) {
      var v = slide.querySelector('.cz-vs__video');
      if (!v || !autoplay || isUserSet(slide)) return;
      if (v.paused && v.muted) {
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      }
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var slide = entry.target;
          var v = slide.querySelector('.cz-vs__video');
          if (!v) return;
          if (entry.isIntersecting) {
            autoplayIfIdle(slide);
          } else if (!v.paused && !isUserSet(slide)) {
            v.pause();
          }
        });
      }, { root: self.track, threshold: 0.15 });
      this.querySelectorAll('.cz-vs__slide').forEach(function (s) { io.observe(s); });
    }

    /* Open on the middle of the strip so slides run off both edges rather than
       only to the right.

       Scrolls to the middle SLIDE rather than to a raw midpoint. The track is
       scroll-snap-type: x mandatory, so an arbitrary scrollLeft is immediately
       corrected to the nearest snap point and thrown away — which is why mobile,
       where slides are 62% wide and the correction is large, never appeared to
       centre at all. Targeting a slide means the destination IS a snap point.

       The observer only fires on intersection *changes*, so slides already in
       view after this jump would sit waiting for a scroll that never comes.
       Hence the explicit sweep afterwards. */
    if (this.hasAttribute('data-center-start')) {
      requestAnimationFrame(function () {
        var t = self.track;
        var slides = self.slides || [];
        if (slides.length) {
          var mid = slides[Math.floor(slides.length / 2)];
          t.scrollLeft = Math.max(0, mid.offsetLeft - (t.clientWidth - mid.offsetWidth) / 2);
        }
        self.updateBar();
        if (self.syncCenter) self.syncCenter();
        if (self.syncArrows) self.syncArrows();
        requestAnimationFrame(function () {
          (self.slides || []).forEach(autoplayIfIdle);
        });
      });
    } else {
      requestAnimationFrame(function () {
        (self.slides || []).forEach(autoplayIfIdle);
      });
    }

    /* Arrows scroll by one slide. Width is measured from the DOM rather than
       assumed, so it stays correct across breakpoints and slide counts. */
    this.slides = Array.prototype.slice.call(this.querySelectorAll('.cz-vs__slide'));
    var prev = this.querySelector('.cz-vs__arrow--prev');
    var next = this.querySelector('.cz-vs__arrow--next');

    function step() {
      var first = self.slides[0];
      if (!first) return self.track.clientWidth;
      var gap = parseFloat(getComputedStyle(self.track).columnGap || getComputedStyle(self.track).gap || 0) || 0;
      return first.getBoundingClientRect().width + gap;
    }
    function nudge(dir) {
      self.track.scrollBy({ left: dir * step(), behavior: 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { nudge(-1); });
    if (next) next.addEventListener('click', function () { nudge(1); });

    this.syncArrows = function () {
      if (!prev || !next) return;
      var max = self.track.scrollWidth - self.track.clientWidth;
      prev.hidden = self.track.scrollLeft <= 2;
      next.hidden = self.track.scrollLeft >= max - 2;
    };

    /* Mark the slide whose centre is nearest the track's centre. Driven off
       scroll position rather than IntersectionObserver so it stays accurate
       mid-scroll, not just at snap points. */
    this.syncCenter = function () {
      if (!self.slides.length) return;
      var box = self.track.getBoundingClientRect();
      var mid = box.left + box.width / 2;
      var best = null, bestD = Infinity;
      self.slides.forEach(function (s) {
        var r = s.getBoundingClientRect();
        var d = Math.abs(r.left + r.width / 2 - mid);
        if (d < bestD) { bestD = d; best = s; }
      });
      self.slides.forEach(function (s) { s.classList.toggle('is-center', s === best); });
    };

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        self.updateBar(); self.syncCenter(); self.syncArrows();
        ticking = false;
      });
    }
    this.track.addEventListener('scroll', onScroll, { passive: true });

    if ('ResizeObserver' in window) {
      new ResizeObserver(function () { self.updateBar(); self.syncCenter(); self.syncArrows(); }).observe(this.track);
    } else {
      window.addEventListener('resize', function () { self.updateBar(); self.syncCenter(); self.syncArrows(); });
    }

    this.updateBar();
    this.syncCenter();
    this.syncArrows();
  };

  CzVideoSlider.prototype.pauseAll = function (except) {
    this.videos.forEach(function (v) {
      if (v !== except && !v.paused) v.pause();
    });
  };

  // Thumb width is the visible fraction of the track; its offset is the scroll
  // fraction of the remaining space, so it reads like a native scrollbar.
  CzVideoSlider.prototype.updateBar = function () {
    var t = this.track;
    if (!t || !this.thumb) return;
    var scrollable = t.scrollWidth - t.clientWidth;
    if (scrollable <= 1) { this.classList.add('cz-vs--no-scroll'); return; }
    this.classList.remove('cz-vs--no-scroll');
    var ratio = Math.min(1, t.clientWidth / t.scrollWidth);
    var progress = Math.min(1, Math.max(0, t.scrollLeft / scrollable));
    this.thumb.style.width = (ratio * 100) + '%';
    this.thumb.style.transform = 'translateX(' + (progress * (100 / ratio - 100)) + '%)';
  };

  customElements.define('cz-video-slider', CzVideoSlider);
})();
